"use strict";

var PAGESIZE = 20;

require("./CompanyPublicationActivity.js");
require("./CompanyPublicationActivityTranslator.js");
require("../../company/comments/CompanyCommentsService.js");

function WallActivity(CompanyPublicationActivity, CompanyCommentsService, CompanyPublicationActivityTranslator, $stateParams) {
  return {
    restrict:    "A",
    templateUrl: "partials/company/publications/wall-activity.html",
    scope: {
      source:   "=wallActivity",
      user:     "=user",
    },
    link: function($scope) {
      $scope.newComment = "";
      $scope.loading    = false;
      $scope.page       = 0;
      $scope.activity   = [];
      $scope.PAGESIZE   = PAGESIZE;

      $scope.loadData = function loadData() {
        $scope.loading = true;
        $scope.page    = $scope.page > 0 ? $scope.page : 0;
        $scope.source.next($scope.page * PAGESIZE, PAGESIZE + 1, ['COMMENT']).then(function(activity) {
          $scope.hasNextPage = activity.length > PAGESIZE;
          $scope.loading     = false;
          $scope.activity    = activity.map(CompanyPublicationActivityTranslator);
        });
      };

      $scope.$on('notification', function(){
        $scope.source = new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
        $scope.page = 0;
        $scope.loading = true;
        $scope.loadData();
      });

      $scope.searchComments = function(filterText){
        $scope.filterText = filterText;
        $scope.source = new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId, filterText);
        $scope.page = 0;
        $scope.loading = true;
        $scope.loadData();
      };

      $scope.addComment = function addComment(newComment, parentId) {
        if(!newComment.length) {
          return false;
        }
        var c = {
          activityType: "COMMENT",
          user:         $scope.user,
          type:         "comment",
          pageSize: 10
        };

        $scope.loading = true;

        var comment = {
          text: newComment, 
          group: null, 
          objectRelative: {
            id: $stateParams.publicationId
          }, 
          objectRelativeType: 'PUBLICATION', 
          parentId: parentId || null
        };

        CompanyCommentsService.createComment({companyId: $stateParams.companyId}, comment, function(comment) {
          $scope.loading = false;
          c.id = comment.id;
          c.text = comment.text;
          c.createdAt = comment.createdAt;
          c.createdBy = comment.createdBy;
          if(parentId){
            angular.forEach($scope.activity, function(item){
              if(item.id === parentId){
                if(!item.commentChild){
                  item.commentChild = [];
                }
                item.commentChild.push(c);
                if(item.commentChild.length >= item.pageSize){
                  item.pageSize += 10;
                }
              }
            });
          }else{
            $scope.activity.unshift(c);
            $scope.source.prependDataTo("COMMENT", c);
            $scope.hasNextPage = $scope.activity.length > PAGESIZE;
          }
        });

        return false;
      };

      $scope.loadData();
    }
  };
}

angular.module("dokiv")
  .directive("wallActivity", ["CompanyPublicationActivity", "CompanyCommentsService", "CompanyPublicationActivityTranslator", "$stateParams", WallActivity]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationWallDirective.js
// module id = 28
// module chunks = 0